import styled from "styled-components";

export const PrimaryButtonAccent = styled.button`
    border: unset;
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-radius: 31px;
    padding: 15px 24px;
    background: ${({theme}) => theme.accent};
    box-shadow:  0 4px 12px rgba(55, 81, 255, 0.24);
    color: ${({theme}) => theme.white};
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: 20px;
    letter-spacing: 0.2px;
    transition: all 300ms ease;
    outline: none;
    > svg{ 
      margin-left: 20px;
    }
    :hover{
      background: ${({theme}) => theme.blueDark};
      box-shadow: 0 4px 12px rgba(37, 61, 217, 0.32);
      cursor: pointer;
    }
    :disabled{
      opacity: 0.5;
    }

  @media (max-width: ${({theme}) => theme.breakpoints.md}) {
    width: 100%;
  }
`
